<template v-if="$vuetify.breakpoint.smAndDown">
  <v-row justify="center" align="center" class="mobile-breadcrumb">
    <v-icon medium @click="$router.go(-1)" class="breadcrumb-back">fas fa-chevron-left</v-icon>
    <span class="text-subtitle-1 font-weight-bold">{{ $t(title) }}</span>
  </v-row>
</template>

<script>
  export default {
    props: ['title']
  }
</script>
